/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Process_BadgeInputs */

const et_process_badge = /** @type {(inputs: Process_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuidas see töötab?`)
};

const en_process_badge = /** @type {(inputs: Process_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does it work?`)
};

/**
* | output |
* | --- |
* | "How does it work?" |
*
* @param {Process_BadgeInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const process_badge = /** @type {((inputs?: Process_BadgeInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Process_BadgeInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_process_badge(inputs)
	return en_process_badge(inputs)
});